( function () {

    // box sizes
    $( ".list-box-size,.size-meter-wrapper" ).on( "click", function (e) {
       e.preventDefault();
       $( ".box-sizes" ).addClass( "visible" );
    });
    // modal box close
    $( ".modal-dialog-actions" ).on( "click", "button", function (e) {
       e.preventDefault();
       $( ".box-sizes" ).removeClass( "visible" );
    });

    // Step 1
    $( ".packaging-options" ).on( "click", "a", function (e) {
        e.preventDefault();

        // add & remove class selected
        $( ".packaging-options a" ).removeClass( "selected" );
        $( this ).addClass( "selected" );

        // step 1 to step 2
        $( ".step-1 a" ).removeClass( "active" ).addClass( "completed" );
        // step 2 Active
        $( ".step-2 a" ).removeClass( "disabled" ).addClass( "active" );
        $( this ).closest( ".giftbox-page" ).removeClass( "active" );
        $( this ).closest( ".giftbox-page" ).next( ".giftbox-page" ).addClass( "active" );
        
    });


})();